import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-password-guard-dialog',
  standalone: true,
  imports: [ MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, FormsModule ,CommonModule],
  template: `
    <h2 mat-dialog-title>Password Required</h2>
    <mat-dialog-content>
      <mat-form-field appearance="fill" style="width:100%;">
        <mat-label>Password</mat-label>
        <input matInput type="password"
               [(ngModel)]="password"
               (keydown)="onKeyDown()"
               (keyup.enter)="checkPassword()"
               autocomplete="off">
      </mat-form-field>
      <div *ngIf="error" style="color: #d32f2f; margin-top: 8px;">Incorrect password.</div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close(false)">Cancel</button>
      <button mat-flat-button color="primary" (click)="checkPassword()">OK</button>
    </mat-dialog-actions>
  `
})
export class PasswordGuardDialogComponent {
  password = '';
  error = false;
  private readonly validPassword = 'Kolkata@2025';

  constructor(public dialogRef: MatDialogRef<PasswordGuardDialogComponent>) {}

  checkPassword() {
    if (this.password === this.validPassword) {
      this.dialogRef.close(true);
    } else {
      this.error = true;
      // Optionally, clear the password field:
      // this.password = '';
    }
  }

  onKeyDown() {
    if (this.error) {
      this.error = false;
    }
  }
}